var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcanaCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.375 17.2188H10.6875C11.0141 17.2188 11.2812 16.9516 11.2812 16.625V14.25H13.0625V16.625C13.0625 17.935 11.9975 19 10.6875 19H2.375C1.06318 19 0 17.935 0 16.625V8.3125C0 7.00254 1.06318 5.9375 2.375 5.9375H4.75V7.71875H2.375C2.04695 7.71875 1.78125 7.98594 1.78125 8.3125V16.625C1.78125 16.9516 2.04695 17.2188 2.375 17.2188ZM5.9375 2.375C5.9375 1.06318 7.00254 0 8.3125 0H16.625C17.935 0 19 1.06318 19 2.375V10.6875C19 11.9975 17.935 13.0625 16.625 13.0625H8.3125C7.00254 13.0625 5.9375 11.9975 5.9375 10.6875V2.375ZM8.3125 11.2812H16.625C16.9516 11.2812 17.2188 11.0141 17.2188 10.6875V2.375C17.2188 2.04695 16.9516 1.78125 16.625 1.78125H8.3125C7.98594 1.78125 7.71875 2.04695 7.71875 2.375V10.6875C7.71875 11.0141 7.98594 11.2812 8.3125 11.2812Z",
    fill: "#BF96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcanaCopy);
export default __webpack_public_path__ + "static/media/arcana-copy.0c5aa46d995bbd56b67712883e2ec6e6.svg";
export { ForwardRef as ReactComponent };